import { Link } from 'react-router-dom';
import type { Category } from '../types/products';
import Icon, { type IconName } from './Icon';

export default function CategoryCard({ category, index }: { category: Category; index?: string }) {
  return (
    <Link
      to={`/products/${category.slug}`}
      className="editorial-card group flex flex-col overflow-hidden p-7"
    >
      <div className="flex items-start justify-between">
        {index && <span className="index-num">{index}</span>}
        <Icon name={category.icon as IconName} className="h-7 w-7 text-primary/70" />
      </div>
      <h3 className="mt-6 text-xl font-semibold text-text-primary">{category.name}</h3>
      <p className="mt-2 flex-auto text-sm leading-6 text-text-secondary">{category.tagline}</p>
      <div className="mt-5 rule" />
      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
        Explore range
        <Icon name="arrow" className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
